var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProduct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33955 18.3817L25.6056 1.47792L48.8717 18.3817L39.9848 45.7326H11.2264L2.33955 18.3817Z",
    stroke: "#3D8ECC",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0625 16.375C16.4422 16.375 16.75 16.6828 16.75 17.0625V34.25H33.9375C34.3172 34.25 34.625 34.5578 34.625 34.9375C34.625 35.3172 34.3172 35.625 33.9375 35.625H16.0625C15.6828 35.625 15.375 35.3172 15.375 34.9375V17.0625C15.375 16.6828 15.6828 16.375 16.0625 16.375Z",
    fill: "#555555",
    stroke: "#555555",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1789 19.1688C34.5344 19.3021 34.7146 19.6984 34.5813 20.0539L31.4875 28.3039C31.3869 28.5722 31.1304 28.75 30.8438 28.75H27.4305L24.8846 32.5689C24.7703 32.7402 24.5852 32.8514 24.3803 32.8717C24.1753 32.8919 23.972 32.8193 23.8264 32.6736L21.8493 30.6965L19.2346 32.7302C18.9349 32.9633 18.503 32.9093 18.2699 32.6096C18.0367 32.3099 18.0907 31.8779 18.3904 31.6448L21.4842 29.2386C21.7579 29.0257 22.1472 29.0499 22.3924 29.2951L24.2057 31.1084L26.4905 27.6811C26.618 27.4899 26.8327 27.375 27.0625 27.375H30.3673L33.2938 19.5711C33.4271 19.2156 33.8234 19.0355 34.1789 19.1688Z",
    fill: "#3D8ECC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.e6e0ecb7b7342f62f677c1eaaa282e6a.svg";
export { ForwardRef as ReactComponent };